import * as Yup from "yup";
import dayjs from "dayjs";

// export const validationSchema = Yup.object({
//     paymentType: Yup
//         .string()
//         .required("Required"),
//     paymentDate: Yup
//         .string()
//         .required("Required"),
//     paymentAction: Yup
//         .string()
//         .required("Required"),
//     bankName: Yup
//         .string()
//         .required("Required"),
//     bankAccount_no: Yup
//         .string()
//         .required("Required"),
//     bankAccount_name: Yup
//         .string()
//         .required("Required"),
//     receiveAmount: Yup
//         .string()
//         .required("Required"),
//     paymentReference: Yup
//         .string()
//         .required("Required"),
//     paymentPostDate: Yup
//         .string()
//         .required("Required"),
// })

export const initialValues = {
    payment_type: "", /* card , cheque , bank_in, cash , e_wallet */
    payment_date: dayjs(), /* YYYY-MM-DD */
    payment_action: "", /* E.g. cash_sales */
    bank_name: "",
    bank_account_no: "",
    bank_account_name: "",
    receive_amount: "",
    payment_reference: "",
    payment_post_date: dayjs() /* YYYY-MM-DD */
}